import { render, staticRenderFns } from "./QrAccreditationDetail.vue?vue&type=template&id=778a512e&"
import script from "./QrAccreditationDetail.ts?vue&type=script&lang=ts&"
export * from "./QrAccreditationDetail.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports